"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorInfoSidebar = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
let AuthorInfoSidebar = class AuthorInfoSidebar extends vue_property_decorator_1.Vue {
    close() {
        this.$emit('sidebar-close');
    }
    open(value) {
        this.$emit('sidebar-open');
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], AuthorInfoSidebar.prototype, "author", void 0);
AuthorInfoSidebar = __decorate([
    vue_property_decorator_1.Component({
        name: 'AuthorInfoSidebar',
        components: {
            BootstrapImage: front_1.BootstrapImage,
            BootstrapIcon: front_1.BootstrapIcon,
            BootstrapButton: front_1.BootstrapButton
        },
        template: `
    <div>
    <!-- Sidebar Overlay -->
    <div class="editorial-office-module__sidebar__overlay" @click="close"></div>
    <div class="editorial-office-module__sidebar">

      <div class="editorial-office-module__sidebar__close">
        <BootstrapButton @click="close">
          <BootstrapIcon size="large" name="close" />
        </BootstrapButton>
      </div>

      <div v-if="author" class="editorial-office-module__sidebar__content">
        <!-- Image -->
        <div class="editorial-office-module__sidebar__content__image">
          <BootstrapImage v-bind="author.avatar"/>
        </div>
        <!-- Author full name -->
        <div class="editorial-office-module__sidebar__content__full_name">
          <p>{{author.firstName}} {{author.lastName}}</p>
        </div>
        <!-- Author position -->
        <div v-if="author.position" class="editorial-office-module__sidebar__content__position">
          <span>{{author.position}}</span>
        </div>
        <!-- Author description -->
        <div v-if="author.description" class="editorial-office-module__sidebar__content__description">
          <p>{{author.description}}</p>
        </div>
      </div>

    </div>
    </div>`
    })
], AuthorInfoSidebar);
exports.AuthorInfoSidebar = AuthorInfoSidebar;
//# sourceMappingURL=AuthorInfoSidebar.ui.js.map